/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class QueryCostData400Response {
  'error'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "error",
      "baseName": "error",
      "type": "string",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return QueryCostData400Response.attributeTypeMap;
  }

  public constructor() {
  }
}

